export default __webpack_public_path__ + "static/media/PAULAS CHOICE INTERVIEW_FINWEB6.b51ddbc9.png";